<svelte:options accessors/>
<script>
    import NauiExplorer from "../../naui/pages/NauiExplorer.svelte";

    export let data;
    export let columns;
    export let pages;
    export let filters;
    export let count;

    export let bodegas;
    export let m3;
</script>

<div class="py-15">
    <NauiExplorer {data} {pages} {count} {columns} {filters}
                  searchLabel="Buscar por # de bodega o cliente" paginate={true} on:filter on:next>
        <div slot="actions">
            <div class="flex sx-iii">
                Total Bodegas {bodegas} | Total m3 {m3}
            </div>
        </div>
    </NauiExplorer>
</div>
